import availabilityApiService from './services/availability.api.service';
import startTimeApiService from './services/startTime.api.service';
import quantityApiService from './services/quantity.api.service';
import offerService from './services/offer.api.service';

let availabilityModule = angular.module('spabooker.availability', [])
    .factory('availabilityApiService', availabilityApiService)
    .factory('startTimeApiService', startTimeApiService)
    .factory('quantityApiService', quantityApiService)
    .factory('offerService', offerService)
    ;
export default availabilityModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/availability/index.js